import { useUserStore } from "../store/user";
import axios from "axios";
import router from "../router";
import HttpStatus from "http-status";
import Vue from "vue";
import Urls from "@/urls";
const userStore = useUserStore();

const config = {
  baseURL: process.env.baseUrl,
  timeout: 60 * 1000, // Timeout
  headers: { Accept: "application/json" },
};

const httpClient = axios.create(config);
const csrfInterceptor = (config) => {
  const csrfToken = document.querySelector("meta[name='csrf-token']").content;
  const csrfHeader = document.querySelector("meta[name='csrf-param']").content;

  config.headers.common[csrfHeader] = csrfToken;

  return config;
};

const errorInterceptor = (error) => {
  if (error.response) {
    const response = error.response;
    switch (response.status) {
      case HttpStatus.FORBIDDEN:
        if (response.data.is_staff) {
          userStore.clearUser();
          router
            .push({
              name: "forbidden",
              params: { message: response.data.error_message },
            })
            .catch((err) =>
              console.error("error occurred from router: " + err)
            );
        } else if (response.data.error_message || response.data.message) {
          router
            .push({
              name: "forbidden",
              params: {
                message: response.data.error_message || response.data.message,
              },
            })
            .catch((err) =>
              console.error("error occurred from router: " + err)
            );
        }
        break;
      case HttpStatus.UNAUTHORIZED:
        userStore.clearUser();
        if (
          router.currentRoute.meta.requiresAuth ||
          router.currentRoute.meta.ncaaAppAdminOnly ||
          router.currentRoute.meta.ncaaStaffOnly
        ) {
          Vue.prototype.$notify.error("Your login session has expired.");
          location.assign(Urls.login);
        }
        break;
      case HttpStatus.INTERNAL_SERVER_ERROR:
        Vue.prototype.$notify.error("An unexpected server error has occurred.");
        break;
      case HttpStatus.NOT_FOUND:
        router
          .push({
            name: "pageNotFound",
            params: { message: response.data.message },
          })
          .catch((err) => console.error("error occurred from router: " + err));
        break;
      default:
        Vue.prototype.$notify.error(error.response.data.message);
        console.error(error.response.status, error.message);
    }
  }

  return Promise.reject(error);
};

const responseInterceptor = (response) => {
  switch (response.status) {
    case HttpStatus.OK:
      // If we need to do anything for good responses add here
      break;
    default:
  }

  return response;
};

httpClient.interceptors.request.use(csrfInterceptor);
httpClient.interceptors.response.use(responseInterceptor, errorInterceptor);

export default httpClient;
